module.exports = __webpack_public_path__ + "img/UP380C&BT.8b1e0802.png";